import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/new/map-ar.svg")